export default __webpack_public_path__ + "static/media/screenshare.f1753c6e.png";